import { TdImageProps } from './type';

export type ImageProps = TdImageProps;
export * from './props';
export * from './image';
